// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "Datáfono",
    description: "Cobra con el datáfono de recepción desde la ficha de la reserva",
    count: "{count} datáfono | {count} datáfonos",
  },
  settings: {
    title: "Datáfonos de recepción",
    lead: "Cobra con el datáfono desde la ficha de la reserva: el importe aparece en el aparato, el huésped pasa la tarjeta y la reserva queda pagada sola.",
    listTitle: "Tus datáfonos",
    add: "Añadir datáfono",
    loading: "Cargando…",
    empty: "Todavía no tienes ningún datáfono conectado.",
    simulatorTag: "Simulador",
    online: "En línea",
    offlineSince: "Desconectado · última señal {when}",
    neverConnected: "Aún no se ha conectado",
    bridgeVersion: "puente {version}",
    token: "token",
    newToken: "Nuevo token",
    remove: "Quitar",
    howTitle: "Cómo se conecta",
    how1: "Añade el datáfono aquí y copia su token (solo se enseña una vez).",
    how2: "En el ordenador de recepción al que va enchufado el datáfono, arranca el puente de WACheckin con ese token.",
    how3: "Cuando aquí salga «En línea», ya puedes cobrar desde la ficha de cualquier reserva: Agregar pago → Tarjeta / datáfono.",
    bankNote: "Con Redsys hace falta contratar con tu banco el «TPV-PC» (modalidad Implantado) y un datáfono certificado para él. Un datáfono normal que funciona solo, por WiFi o 4G, no se puede conectar.",
    addTitle: "Añadir datáfono",
    nameLabel: "Nombre",
    namePlaceholder: "Por ejemplo: Recepción",
    typeLabel: "Tipo",
    typeReal: "Datáfono de Redsys (TPV-PC)",
    typeRealHint: "El datáfono de tu banco, enchufado al ordenador de recepción.",
    typeSim: "Simulador",
    typeSimHint: "Para probar el recorrido sin aparato. No mueve dinero.",
    cancel: "Cancelar",
    saving: "Guardando…",
    create: "Añadir",
    saveError: "No se pudo guardar. Inténtalo de nuevo.",
    loadError: "No se pudieron cargar los datáfonos.",
    tokenTitle: "Token del datáfono",
    tokenLead: "Pon estos dos datos en el puente del ordenador de recepción.",
    apiLabel: "Servidor",
    tokenLabel: "Token",
    copy: "Copiar",
    copied: "Copiado",
    tokenOnce: "Guárdalo ahora: no se vuelve a enseñar. Si se pierde, genera uno nuevo y el anterior deja de valer.",
    done: "Hecho",
    newTokenConfirm: "¿Generar un token nuevo para «{name}»? El actual dejará de valer y habrá que ponerlo otra vez en el puente.",
    removeConfirm: "¿Quitar el datáfono «{name}»? Ya no se le podrán mandar cobros.",
    removed: "Datáfono quitado.",
  },
  add: {
    sendTitle: "Cobrar en el datáfono",
    sendHint: "El importe aparece en el aparato y la reserva se marca pagada sola al pasar la tarjeta.",
    online: "en línea",
    offline: "desconectado",
    noneOnline: "Ningún datáfono está en línea ahora. Comprueba que el ordenador de recepción esté encendido y el puente abierto.",
    manualTitle: "Ya lo cobré, solo anotarlo",
    manualHint: "Se registra como pagado sin pasar por el datáfono.",
    submit: "Cobrar en el datáfono",
  },
  line: {
    pendiente: "Enviando al datáfono",
    enviado: "En el datáfono",
    sin_respuesta: "Sin respuesta · revisar",
  },
  cobro: {
    terminal: "Datáfono",
    cancel: "Cancelar el cobro",
    hide: "Seguir en segundo plano",
    notCharged: "No se cobró",
    wasCharged: "Sí, se cobró",
    retry: "Volver a intentar",
    close: "Cerrar",
    authCode: "Autorización {code}",
    genericError: "No se pudo completar. Inténtalo de nuevo.",
    title: {
      pendiente: "Enviando al datáfono…",
      enviado: "Pide que pasen la tarjeta",
      cobrado: "Cobrado",
      rechazado: "Tarjeta denegada",
      cancelado: "Cobro cancelado",
      error: "El datáfono dio un error",
      caducado: "El datáfono no respondió",
      sin_respuesta: "¿Se ha cobrado?",
    },
    text: {
      pendiente: "En unos segundos aparecerá el importe en el datáfono.",
      enviado: "El importe ya está en el datáfono. En cuanto se pague, la reserva se marca sola.",
      cobrado: "La reserva ya tiene este pago registrado.",
      rechazado: "No se ha cobrado nada.",
      cancelado: "No se ha cobrado nada.",
      error: "No se ha cobrado nada.",
      caducado: "No se ha cobrado nada.",
      sin_respuesta: "El datáfono no devolvió el resultado. Míralo en el aparato o en su ticket antes de volver a cobrar.",
    },
  },
  qr: {
    button: "Mostrar QR",
    title: "Escanea para pagar",
    text: "El huésped lo escanea con el móvil y paga en la página segura de la pasarela. La reserva se marca pagada sola.",
    copy: "Copiar enlace",
    copied: "Enlace copiado",
    close: "Cerrar",
  },
};
